import api from './api';

export type GatewayExeProduct = 'data_gateway' | 'control_room';

export type GatewayExeTarget = {
  pool_id: number | null;
  state: string;
  detail?: string;
  command_id?: string | null;
  updated_at?: string;
};

export type GatewayExeJob = {
  id: string;
  product: GatewayExeProduct;
  original_name?: string;
  staged_name?: string;
  target_name?: string;
  mode?: 'swap' | 'save';
  sha256?: string;
  size?: number;
  created_at?: string;
  targets?: GatewayExeTarget[];
};

export type GatewayExePool = {
  id: number;
  code: string;
  name: string;
};

export async function fetchGatewayExeTargets(): Promise<{
  pools: GatewayExePool[];
  control_room_online: boolean;
}> {
  return api.get('/api/gateway-exe-updates/targets', undefined, { useCache: false });
}

export async function fetchGatewayExeJobs(): Promise<GatewayExeJob[]> {
  const body = await api.get<{ items: GatewayExeJob[] }>(
    '/api/gateway-exe-updates/',
    undefined,
    { useCache: false },
  );
  return Array.isArray(body?.items) ? body.items : [];
}

export async function uploadGatewayExe(params: {
  file: File;
  product: GatewayExeProduct;
  poolIds: number[];
}): Promise<GatewayExeJob> {
  const form = new FormData();
  form.append('file', params.file);
  form.append('product', params.product);
  form.append('pool_ids', params.poolIds.join(','));
  const body = await api.post<{ job: GatewayExeJob }>('/api/gateway-exe-updates/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000,
  });
  return body.job;
}

export async function redispatchGatewayExe(jobId: string): Promise<GatewayExeJob> {
  const body = await api.post<{ job: GatewayExeJob }>(
    `/api/gateway-exe-updates/${jobId}/dispatch`,
    {},
  );
  return body.job;
}

export async function deleteGatewayExeJobs(ids: string[]): Promise<{ count: number }> {
  const body = await api.post<{ ok: boolean; count: number }>(
    '/api/gateway-exe-updates/delete',
    { ids },
  );
  return { count: Number(body?.count || 0) };
}
